import React, {useEffect, useState} from "react";

import {Spinner} from "../../../../shared";
import SocketUtils from "../../socket-utils/socketUtils";
import logo from "../../../../../images/logos/squadDiskHR.png";
import {cn} from "../../../../../utils/utils";

import './squadflix-tv.css';
import './squadflix-tv--with-item.scss'
import {SquadflixLinkingApi} from "../../../../../apis/squadflix-linking-api/squadflix-linking-api";
import {ApiCallError} from "../../../../../apis/torrestream-api/torresstream-api";

const SquadflixTv = ({device, onDeletedDevice, selectedItem, mainItem, video}) => {

    const [loading, setLoading] = useState(true);
    const [owner, setOwner] = useState(null);
    const [itemName, setItemName] = useState("SquadFlix TV");
    const [subtitle, setSubtitle] = useState("");
    const [btnFocused, setBtnFocused] = useState("");

    useEffect(() => {
        if (!mainItem || !selectedItem) {
            return;
        }

        const name = mainItem.title ?? mainItem.name;
        setItemName(name);

        const itemDtls = selectedItem.type === 'movie' ? (selectedItem.release_date ? new Date(selectedItem.release_date).getFullYear() : '') : (selectedItem.episode_number && selectedItem.season_number ? `S${selectedItem.season_number} E${selectedItem.episode_number}` : '');
        setSubtitle(itemDtls);
    }, [selectedItem, mainItem]);

    useEffect(() => {
        SquadflixLinkingApi.getOwnerUserDetails({deviceId: device.deviceId, uid: device.uid}).then(res => {
            setOwner(res);
        }).catch(err => {
            if (err instanceof ApiCallError) {
                if (err.code == 401) {
                    onDeletedDevice();
                    return;
                }
            }
            console.log(err);
        }).finally(() => {
            setLoading(false);
        })
    }, [device]);

    useEffect(() => {

        const handleDeleteLink = () => {
            onDeletedDevice();
        }

        SocketUtils.on("delete_link", handleDeleteLink);

        return () => {
            SocketUtils.off("delete_link", handleDeleteLink);
        }

    }, [onDeletedDevice]);

    useEffect(() => {

        const handleClickKey = (e) => {
            console.log(e);
        }

        window.addEventListener("keydown", handleClickKey);

        return () => {
            window.removeEventListener("keydown", handleClickKey);
        }

    }, []);

    if (loading) {
        return <div className="d-flex justify-content-center align-items-center vh-100">
            <Spinner/>
        </div>
    }

    if (!owner) {
        return null;
    }

    return <div className={cn("squadflix-tv", {"squadflix-tv--with-item": !!selectedItem})}>

        <button
            className={cn("squadflix-tv__user-info", {"squadflix-tv__user-info--focused": btnFocused == 'user-info'})}
            tabIndex={0}
            onBlur={() => setBtnFocused('')}
            onClick={() => console.log('click')}
            onFocus={() => setBtnFocused('user-info')}>
            <span>
                {owner.displayName}
            </span>
            <img src={owner.photoURL} alt={owner.displayName + "_photo"}/>
        </button>

        <div>
            <div className="squadflix-tv__main-item">
                <div>
                    {itemName}
                </div>
                <div>
                    {subtitle}
                </div>
            </div>
        </div>

        <div className="device-linking__img">
            <div className="device-linking__img-container">
                <img width={600} src={logo} alt="Squadflix Logo" className="device-linking-logo" style={{}}/>
                <span className="device-linking__img-container-label">SquadFlix TV</span>
            </div>
        </div>

        <div className="squadflix-tv__info-status">
            <div>
                <small>{device.name}</small>
            </div>
            <span>Listo para recibir contenido de SquadFlix desde tu dispositivo</span>
        </div>

        <div style={{
            textAlign: 'center',
            width: "100%",
            position: 'absolute',
            bottom: 10,
            fontSize: '0.7em',
            color: '#888',
            zIndex: 3
        }}>
            <div style={{textDecoration: "underline"}}>device id</div>
            {device.deviceId}
        </div>
    </div>

}

export default SquadflixTv;
